import { EditorState } from 'draft-js'
import { useState } from 'react'
import { EditorContextType } from '../types/editorContext'

export const useEditorContext = ({ value }: { value?: EditorState }): EditorContextType => {
  const [editorState, setEditorState] = useState(value ? value : EditorState.createEmpty())
  const [editorError, setEditorError] = useState<undefined | string>(undefined)

  const isControlled = value !== undefined

  return {
    editorState: isControlled ? value : editorState,
    setEditorState,
    editorError,
    setEditorError,
    isControlled
  }
}
